import React from "react";
import { Linking } from "react-native";
import { DataTable } from "react-native-paper";
import { TableValueCellComponent } from "./Types";

const linkTextStyle = { textDecorationLine: "underline" as const };

export const TableLinkCell: TableValueCellComponent = ({
  field,
  value,
  t,
  linkColor,
}) => {
  let link = "";

  if (field.type === "url") {
    link = "https://";
  } else if (field.type === "phone") {
    link = "tel:";
  } else if (field.type === "email") {
    link = "mailto:";
  }

  return (
    <DataTable.Cell
      textStyle={[linkTextStyle, { color: linkColor }]}
      onPress={() => Linking.openURL(link + value)}
    >
      {t(value)}
    </DataTable.Cell>
  );
};
